// Obtener moneda por país
export const getCurrencyByCountry = async (country: String) => {
  const data = await $fetch('/country') // obtener monedas
  const moneda = data?.find((item) => item.country_id === country)?.currency // elegir moneda dependiendo del país elegido
  return moneda ?? 'EUR'
}

// Obtener moneda por país
export const getLangByCountry = async (country: String) => {
  const { data } = await useLazyFetch('/country') // obtener monedas
  const lang = data.value?.find((item) => item.country_id === country)?.lang // elegir moneda dependiendo del país elegido
  return lang?.toLowerCase() ?? 'es'
}